// Helper puro para "subir un nivel" de la jerarquía de rutas.
//
// Regla: subir al ancestro real más cercano que sea una ruta registrada (ver constants/appRoutes.js).
// NO se quita un segmento a ciegas: si el padre calculado no matchea ninguna ruta real, se sigue
// subiendo hasta encontrar una, con piso en "/admin".
//
// Casos (ver App.js):
//   /categorias/automotriz              -> /categorias
//   /categorias                         -> /admin           (no hay ancestro intermedio, cae al piso)
//   /admin/facturacion                  -> /admin
//   /admin/factura/123                  -> /admin           (/admin/factura no existe sin :id)
//   /admin/oportunidades/editar/123     -> /admin
//   /admin/online-cotizador/editar/45   -> /admin/online-cotizador  (para en la ruta intermedia real)
//   /admin                              -> /admin           (ya en el piso; el caller decide no navegar)
//
// @param {string} pathname       - location.pathname actual (sin query ni hash).
// @param {(candidate: string) => boolean} isValidRoute - predicado que dice si `candidate` matchea
//                                  alguna ruta real de la app (típicamente vía matchRoutes).
// @returns {string} el path del ancestro al que subir. Piso: "/admin".
export const FLOOR_PATH = "/admin";

export function getParentPath(pathname, isValidRoute) {
  if (typeof pathname !== "string" || pathname.length === 0) {
    return FLOOR_PATH;
  }

  // Normalizar: quitar barras finales redundantes.
  const normalized = pathname.replace(/\/+$/, "");
  const segments = normalized.split("/").filter(Boolean);

  // Subir de a un segmento desde el padre inmediato hacia la raíz.
  for (let i = segments.length - 1; i > 0; i -= 1) {
    const candidate = "/" + segments.slice(0, i).join("/");

    // El piso siempre gana: al llegar a "/admin" no se sigue subiendo.
    if (candidate === FLOOR_PATH) {
      return FLOOR_PATH;
    }

    if (typeof isValidRoute === "function" && isValidRoute(candidate)) {
      return candidate;
    }
  }

  return FLOOR_PATH;
}
